import { useContext } from 'react';
import { ResolutionsContext } from '../resolutions-context';

export const useResolutions = () => {
  const context = useContext(ResolutionsContext);
  if (!context) {
    throw new Error('useResolutions debe usarse dentro de ResolutionsProvider');
  }
  return context;
};
